module.exports = __webpack_public_path__ + "static/media/icono_promotor.aa8b924d.svg";